import React, { useRef, useEffect } from "react";
import { gsap } from "gsap";

function Gsap() {
  const boxRef = useRef();

  useEffect(() => {
    gsap.to(boxRef.current, {
      x: 200,
      duration: 1,
      rotation: 360
    });
  }, []);

  return (
    <div>
      <div
        ref={boxRef}
        className="test-gsap-box"
      />
    </div>
  );
}

export default Gsap;